module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// d:/workspace/wynk_web_shoppings_3_prod/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main